import { MERCHANT_COMMERCIAL, FLAT_FEE, IS_CHARGE_ON_CUSTOMER, PARTNER_COMMISSION } from '../const';
import CustomTooltip from '../CustomToolTip';

export const commonFields = [
  {
    type: 'number',
    label: 'Min Amount',
    key: 'min_amount',
    disable: true,
    validator: () => {}
  },
  {
    type: 'number',
    label: 'Max Amount',
    key: 'max_amount',
    disable: true,
    validator: () => {}
  },
  {
    type: 'switch',
    label: <CustomTooltip label={IS_CHARGE_ON_CUSTOMER} />,
    key: 'surcharge_flag',
    warningText: 'Flag Change',
    disable: true,
    span: 3,
    validator: () => {}
  },

  // {
  //   type: 'text',
  //   label: 'Commission Type',
  //   key: 'commission_type',
  //   disable: true,
  //   validator: () => {}
  // },
  // {
  //   type: 'text',
  //   label: 'Commercial Type',
  //   key: 'commercial_type',
  //   disable: true,
  //   validator: () => {}
  // },

  {
    type: 'number',
    label: <CustomTooltip label={MERCHANT_COMMERCIAL} />,
    key: 'merchant_commercial',
    warningText: 'Old',
    disable: true,
    validator: () => {}
  },

  {
    type: 'number',
    label: <CustomTooltip label={PARTNER_COMMISSION} />,
    key: 'partner_commission',
    warningText: 'Old',
    disable: true,
    validator: () => {}
  },
  {
    type: 'number',
    label: <CustomTooltip label={FLAT_FEE} />,
    key: 'flat_fee',
    warningText: 'Old',
    disable: true,
    validator: () => {}
  }
];

export const linkSolutionFields = {
  span: 4,
  default: {
    primary: commonFields,
    differential: commonFields
  },
  international: {
    primary: commonFields,
    differential: commonFields
  },

  corporate: {
    primary: commonFields,
    differential: commonFields
  },
  pos_upi_cc: {
    primary: commonFields,
    differential: commonFields
  },
  upi_cc: {
    primary: commonFields,
    differential: commonFields
  }
};
